import { useSelector } from "react-redux";
import { AppState } from "../store/app-state";
import { UtmEvent } from "./use-utm-builder";
import User from "../models/user.model";

const useUmamiTracking = () => {
  // @ts-ignore
  const umami = window.umami;
  const { user } = useSelector((state: AppState) => state.authState);
  
  const getUserData = (userProfile?: User | null) => {
    if (userProfile && userProfile.id) return {
      id: userProfile.id,
      name: userProfile.name,
      corporate: userProfile.corporate
    };

    if (user && user.id) return {
      id: user.id,
      name: user.name,
    };

    return {};
  }

  const pushUmami = (name: string, event: UtmEvent | any, userProfile?: User | null) => {
    try {
      const userData = getUserData(userProfile);
      umami.trackEvent(
        name,
        { user: userData, event: event },
        `${window.location.pathname}${window.location.search}`,
        process.env.REACT_APP_TALENT_UMAMI_SITE_ID
      );
    } catch (error) {
      console.log(error);
    }
  };

  return pushUmami;
};

export default useUmamiTracking;
